<template>
	<div class="resource-dashboard-wrapper">
		<ja-resource-dashboard
			v-for="category in resourceCategories"
			:key="category.resourceCategory_ID"
			:title="category.name"
			:resources="category.cmsResources"
			@imageSelected="onImageSelected"
			@fileRequested="downloadResource"
		></ja-resource-dashboard>
		<ja-image-preview
			:image="selectedImage"
			@fileRequested="downloadResource"
			@closeModal="onModalClosed"
		></ja-image-preview>
	</div>
</template>
<script>
import ResourceDashboard from '../elements/ResourceDashboard';
import ImagePreview from '../modals/ImagePreview';
import ResourcesService from '@/services/ResourcesService';
import AdminFacility from '@/mixins/AdminFacility';

export default {
	components: {
		jaResourceDashboard: ResourceDashboard,
		jaImagePreview: ImagePreview
	},
	mixins: [AdminFacility],
	data() {
		return {
			resourceCategories: [],
			selectedImage: null,
			fileExtensions: {
				'application/msword': 'doc',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
					'docx',
				'image/png': 'png',
				'image/jpeg': 'jpg',
				'application/pdf': 'pdf'
			}
		};
	},
	watch: {
		selectedFacility() {
			this.fetchResources();
		}
	},
	mounted() {
		this.fetchResources();
	},
	methods: {
		fetchResources() {
			if (this.selectedFacilityId != null) {
				this.$store.commit('setLoading', true);
				ResourcesService.getAllCategories(this.selectedFacilityId).then(
					resources => {
						this.resourceCategories = resources;
						this.$store.commit('setLoading', false);
					}
				);
			}
		},
		onModalClosed() {
			this.selectedImage = null;
		},
		onImageSelected(image) {
			this.selectedImage = image;
		},
		downloadResource(resource) {
			const byteCharacters = atob(resource.fileDataBase64);

			const byteNumbers = new Array(byteCharacters.length);
			for (let i = 0; i < byteCharacters.length; i++) {
				byteNumbers[i] = byteCharacters.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);

			const blob = new Blob([byteArray], { type: resource.fileType });
			const fileName = `${resource.name}.${
				this.fileExtensions[resource.fileType]
			}`;

			if (window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveBlob(blob, fileName);
			} else {
				var elem = window.document.createElement('a');
				elem.href = window.URL.createObjectURL(blob);
				elem.download = fileName;
				document.body.appendChild(elem);
				elem.click();
				document.body.removeChild(elem);
			}
		},
		updateTemplates(value) {
			this.selectedFacilityID = value;
			this.fetchResources();
		}
	}
};
</script>
<style lang="scss" scoped>
.resource-dashboard-wrapper {
	width: 100%;

	.facility-dropdown-container {
		margin: auto;
		width: 100%;
		max-width: 1000px;
		margin-top: 32px;
		margin-bottom: 32px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		justify-content: space-between;
	}

	.resource-dashboard {
		margin: auto;
		max-width: 1000px;
	}
}
</style>
